<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  font: {
    type: String,
    default: '',
  },
  mainColor: {
    type: String,
    default: '',
  },
  headerSeparator: {
    type: String,
    default: '',
  },
  herName: {
    type: String,
    default: '',
  },
  hisName: {
    type: String,
    default: '',
  },
});

const headerTextFont =
  props.font && props.font.trim() !== '' ? props.font : 'Parisienne';

const isOneLineNames = ref(false);
const headWithNamesRef = ref<HTMLDivElement | null>();
const namesSeparatorRef = ref<HTMLHeadingElement | null>();
const herNameRef = ref<HTMLHeadingElement | null>();
const hisNameRef = ref<HTMLHeadingElement | null>();

const isSeparator = computed(() => {
  return props.headerSeparator && props.headerSeparator !== '';
});

function checkWidth() {
  const gapSize = 40;
  const containerWidth = headWithNamesRef.value?.offsetWidth ?? 0;
  const itemsWidth =
    (herNameRef.value?.offsetWidth ?? 0) +
    (namesSeparatorRef.value?.offsetWidth ?? 0) +
    (hisNameRef.value?.offsetWidth ?? 0) +
    gapSize;
  isOneLineNames.value = itemsWidth <= containerWidth;
}

onMounted(() => {
  checkWidth();
  window.addEventListener('resize', checkWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkWidth);
});
</script>

<template>
  <div
    ref="headWithNamesRef"
    class="head"
    :class="{ 'one-line': isOneLineNames }"
  >
    <h1 ref="herNameRef" class="header">
      {{ herName }}
    </h1>
    <h1 v-show="isSeparator" ref="namesSeparatorRef" class="header">
      {{ headerSeparator }}
    </h1>
    <h1 ref="hisNameRef" class="header">
      {{ hisName }}
    </h1>
  </div>
</template>

<style lang="scss" scoped>
.head {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px 17px;
  font-size: 16px;

  .header {
    color: v-bind(mainColor);
    width: auto;
    font-size: 7em;
    font-size: clamp(3em, 10vw, 7em);
    line-height: 1em;
    text-align: center;
    font-family: v-bind(headerTextFont), cursive;

    @media screen and (max-width: $media-max-phone) {
      font-size: 3.25em;
      font-size: clamp(3em, 10vw, 7em);
    }
  }
}

.one-line {
  flex-direction: row;
}
</style>
